import React, { useEffect, useState } from "react";
import "../../styles/Industries.css";
import { RiArrowRightSLine } from "react-icons/ri";
import Entertainment_bg_img from "../../bg_images/I_entertainment_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";


const Servicecards = [
  {
    title: "Enhancing Audience Engagement",
    text: " Leverage technology to create more immersive, interactive, and personalized entertainment experiences to captivate audiences. ",
  },
  {
    title: "Optimizing Content Delivery",
    text: " Ensure seamless and high-quality content delivery across all platforms and devices, globally. ",
  },
  {
    title: " Combating Digital Piracy and Protecting Content ",
    text: " Implement robust security measures to protect valuable digital assets and intellectual property. ",
  },
  {
    title: " Adapting to Evolving Consumption Habits ",
    text: "Embrace new technologies and platforms to meet changing audience preferences and consumption patterns. ",
  },
  {
    title: "Leveraging Data for Content Strategy",
    text: " Utilize data analytics to understand audience preferences and optimize content creation, distribution, and marketing. ",
  },
];

const Entertainment = () => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleServicecards, setVisibleServicecards] = useState(3);

  useEffect(() => {
    const updateVisibleServicecards = () => {
      if (window.innerWidth <= 768) {
        setVisibleServicecards(1);
      } else {
        setVisibleServicecards(3);
      }
    };

    updateVisibleServicecards();
    window.addEventListener("resize", updateVisibleServicecards);
    return () =>
      window.removeEventListener("resize", updateVisibleServicecards);
  }, []);

  const handleNext = () => {
    if (currentIndex + visibleServicecards < Servicecards.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div className="Industries">
      <div
        className="I_sec1"
        style={{ backgroundImage: `url(${Entertainment_bg_img})` }}
      >
        <h5>
          Industries <RiArrowRightSLine className="servrighticon" />{" "}
          Entertainment
        </h5>
        <h1>
          {" "}
          Powering the Future of Entertainment with Cutting-Edge Technology
        </h1>
        <p>
          Arshil provides IT solutions to empower entertainment companies to
          captivate audiences, streamline operations, and stay ahead of the
          curve.
        </p>
        <button
          onClick={() => navigate("/services/ApplicationDevelopment")}
          className="S_sec1_btn1"
        >
          Explore Entertainment Tech Solutions
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 2 */}

      <div className="I_sec2">
        <h2>What We Offer Our Entertainment Customers</h2>
        <section className="I_sec2_cardsContainer">
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/et_sec2_icon1.svg"
                alt=""
              />
              Immersive Digital Experiences
            </h6>
            <p>
              Solutions to create and deliver engaging digital content, from
              streaming platforms to interactive experiences and virtual events.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/et_sec2_icon2.svg"
                alt=""
              />
              Robust Content Delivery Networks (CDNs)
            </h6>
            <p>
              Fast, reliable, and secure content delivery to ensure seamless
              streaming and access for global audiences.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/et_sec2_icon3.svg"
                alt=""
              />
              Data Analytics for Content Optimization
            </h6>
            <p>
              Tools to analyze audience behavior, content performance, and
              trends to inform content creation and marketing strategies.
            </p>
          </section>
          <section className="I_sec2_cards">
            <h6>
              <img
                className="I_sec2_icon"
                src="../svg/et_sec2_icon4.svg"
                alt=""
              />
              Secure Digital Asset Management
            </h6>
            <p>
              Solutions to protect valuable digital assets, manage rights, and
              streamline content workflows.
            </p>
          </section>
        </section>
        <button onClick={() => navigate("/contact")} className="I_sec2_btn1">
          Schedule a free consultation
          <HiArrowNarrowRight className="psec1arrow" />
        </button>
      </div>

      {/* Section 3 */}

      <div className="S_carousel-container">
        <h2 className="S_carousel-title">
          Solving the Key Challenges in Entertainment
        </h2>
        <div className="S_carousel-wrapper">
          <button
            className="arrow left-arrow"
            onClick={handlePrev}
            disabled={currentIndex === 0}
          >
            <MdOutlineKeyboardArrowLeft className="S_rightArrow" />
          </button>

          <div className="S_carousel">
            <div
              className="S_carousel-track"
              style={{
                transform: `translateX(-${
                  currentIndex * (100 / visibleServicecards)
                }%)`,
              }}
            >
              {Servicecards.map((card, index) => (
                <div className="S_carousel-card" key={index}>
                  <h3>{card.title}</h3>
                  <div className="underline"></div>
                  <p>{card.text}</p>
                </div>
              ))}
            </div>
          </div>

          <button
            className="arrow right-arrow"
            onClick={handleNext}
            disabled={currentIndex + visibleServicecards >= Servicecards.length}
          >
            <MdOutlineKeyboardArrowRight className="S_rightArrow" />
          </button>
        </div>
      </div>

      {/* Section 4 */}

      <div className="I_sec4">
        <section className="I_sec4_left">
          <h1>Case Study</h1>
          <h6>
            Elevating Audience Engagement and Streamlining Content Delivery
          </h6>
          <p>
            Arshil transformed a client’s cinema theater management software by
            implementing a cloud-native solution for logging, monitoring, and
            alerting. This scalable system provided real-time insights,
            proactive issue resolution, and optimized resource utilization,
            enhancing performance across theater locations.
          </p>
          {/* <p>
            Discover how we streamlined their operations and delivered
            measurable impact.
          </p> */}
        </section>
        <section className="I_sec4_right">
          <img
            className="I_sec4_img1"
            src="../images/I_entertainment.png"
            alt="entertainment"
          />
        </section>
      </div>

      {/* Section 5  */}

      <div className="I_sec5">
        <section className="I_sec5_left">
          <h4>
            Ready to Transform Your Entertainment Business with Technology?
          </h4>
          <p>
            Let's discuss how our IT solutions can help you innovate, engage
            your audience, and drive success in the entertainment industry.
          </p>
        </section>
        <section className="I_sec5_right">
          <button onClick={() => navigate("/contact")}>
            Request a Free Consultation
            <HiArrowNarrowRight className="I_sec5_arrow_right" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default Entertainment;
